module.exports = __webpack_public_path__ + "img/b.7b5e141c.jpg";